module.exports = {
  LOCAL_BASE_URL: "https://api.angkorenterprise.org/",
  // LOCAL_BASE_URL: "http://localhost:4000/",
  BASE_URL: "https://api.angkorenterprise.org/",
  REACT_APP_PAYMENT_API_URL: "https://api.mistletoe.co.in",
};
